const React = require('react');


module.exports = (props) => {
  return (
    <div
      {...props}
      className={`layoutRow fhaS fvaC h70 ph35 mh-45 mr-37 pv5 cA4A7AC f16
        fw5 bc505255 bs b bb2 ` + (props.className || '')}
    />
  );
};
